import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { Thoughtpopup } from './thoughtpopup';

@NgModule({
  declarations: [
    Thoughtpopup,
  ],
  imports: [
    IonicPageModule.forChild(Thoughtpopup),
  ],
  exports: [
    Thoughtpopup
  ]
})
export class ThoughtpopupModule {}



// WEBPACK FOOTER //
// ./src/pages/thoughtpopup/thoughtpopup.module.ts